import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const GoogleScaleSmallAppearanceDefault = hoc(
    (props: IconProps) => (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M14.5884 6.97255L14.5198 6.68722H8.19624V9.31286H11.974C11.5819 11.1402 9.7616 12.102 8.27467 12.102C7.19297 12.102 6.05245 11.6564 5.29755 10.9382C4.52304 10.2009 4.02957 9.11409 4.02957 7.99523C4.02957 6.8892 4.53611 5.78316 5.27467 5.05542C6.00997 4.33089 7.12435 3.92053 8.23219 3.92053C9.50016 3.92053 10.4087 4.58095 10.7485 4.8823L12.6505 3.02609C12.0917 2.5452 10.559 1.33337 8.1701 1.33337C6.32696 1.33337 4.55899 2.02585 3.26814 3.28897C1.99363 4.53286 1.3335 6.33137 1.3335 7.99844C1.3335 9.6655 1.95768 11.3775 3.19297 12.631C4.51323 13.9678 6.38251 14.6667 8.30735 14.6667C10.059 14.6667 11.7191 13.9935 12.9021 12.772C14.0655 11.5698 14.6668 9.90595 14.6668 8.16194C14.6668 7.42779 14.5917 6.99179 14.5884 6.97255Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Google'
);
export default GoogleScaleSmallAppearanceDefault;
